import { useEffect, useState } from 'react';
import axiosInstance from '../api/axios';

let cached = null;

// Admin-controlled visibility of optional homepage areas (default: hidden)
export const useHomepageVisibility = () => {
  const [data, setData] = useState(cached || { show_collections: false, show_seasonal_landing: false });
  useEffect(() => {
    if (!cached) {
      cached = axiosInstance.get('/settings/homepage-visibility').then((r) => r.data).catch(() => null);
    }
    Promise.resolve(cached).then((d) => d && setData(d));
  }, []);
  return data;
};
